// extracted by mini-css-extract-plugin
export var lg = "_1x-4";
export var md = "_1x-3";
export var sm = "_1x-2";
export var xs = "_1x-1";
export var xxs = "_1x-0";